import type { PayloadAction } from '@reduxjs/toolkit';
import { ERuleSaveStatus } from '../../../data/Constants';
import type { IFeature, IProcosState } from '../../../../types';
import { resetFeatureSaveStatus } from './ProcosReducerHelpers';

export const featureReducers = {
  setStatusOfAllRuleUpdates(state: IProcosState) {
    const featuresData = state.features.data;
    const featuresMA = state.features.ma;

    Object.keys(featuresMA).forEach((key) => {
      if (featuresMA[key].initialMarkets.length !== featuresMA[key].updatedMarkets.length) {
        featuresData?.map((feature: IFeature) => {
          // when key = FUS8528.NUSZ890 and feature.code = NUSZ890
          // This case is true when feature has option data
          if (feature.code === key || key.includes(feature.code)) {
            // For Effectivity feature code saveStatus will have either Success/Failure
            if (!feature.saveStatus) {
              feature.saveStatus = ERuleSaveStatus.Inprogress;
            }
          }
        });
      }
    });

    state.features.data = featuresData;
  },
  resetSaveStatusOfFeatures(state: IProcosState) {
    const featuresData = state.features.data;
    featuresData?.map((feature: IFeature) => {
      if (feature.saveStatus) {
        feature.saveStatus = '';
      }
    });

    state.features.data = featuresData;
  },
  setFeatureStatus(state: IProcosState, action: PayloadAction<any>) {
    state.featureStatus = action.payload;
  },
  setFeatureData(state: IProcosState, action: PayloadAction<any>) {
    state.features.data = action.payload;
  },
  updateFeatureStatus(state: IProcosState, action: PayloadAction<any>) {
    state.features.status.updated = action.payload;
    resetFeatureSaveStatus(state);
    state.isDataUpdated = true;
  },
  setFeatureRecordsPerPage(state: IProcosState, action: PayloadAction<any>) {
    state.features.recordsPerPage = action.payload;
  },
};
